import axios from 'axios';
import Qs from 'qs';
import {
	dayEnd,
	dayStart,
} from "../../components/DateUtil";
import { BASEURL } from '../common/config'
// const url = BASEURL
const url = 'http://10.10.1.198:37077/' //公司线上服务器



// 通过回路id查询极值
export const EXTREMUM_VALUES = (ids, nodes, type, date) => {
	return axiosApi("get", "/extremum/values")({
		ids: ids.join(","),
		nodes: nodes.join(","),
		type,
		"start": dayStart(date),
		"end": dayEnd(date),
	})
}

/**
 * 用Create方法来创建axios请求对象
 */

export const INITAXIOS = axios.create({
    timeout: 30000, // 请求超时时间
    baseURL: url, //线上公司服务器
    method: 'post',
    headers: {
        'Content-Type': "application/x-www-form-urlencoded",
    },
    transformRequest: data => {
        let result = Qs.stringify(data);
        return result
    }
})

/**
 * 用来创建普通请求方法
 * @param api
 * @returns {function(*=): Promise<AxiosResponse<T>>}
 */
export function axiosApi(type, api, header) {
    header ? header : header = {};
    return data => {
        switch (type) {
            case 'get':
                return INITAXIOS({
                    url: api,
                    params: data,
                    method: 'get',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
            case 'post':
                return INITAXIOS({
                    url: api,
                    data: data,
                    method: 'post',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
            case 'put':
                return INITAXIOS({
                    url: api,
                    data: data,
                    method: 'put',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
            case 'delete':
                return INITAXIOS({
                    url: api,
                    data: data,
                    method: 'delete',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
        }
    }
}

//视频流
export function getVideo({cameraIndexCode,type}) {
    return axiosApi("get", "/access/video/url/get/"+cameraIndexCode+"/"+type, true)()
}



